import Product from "./Product";

export default function Standard({ product }){

    return product &&

        <Product product={product}>

            <div className="apply-option-title">
                <span>Achat direct</span>
            </div>

            <div className="apply-option-row">
                <span>Accès immédiat</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Déductible des frais professionnels et crédit d'impôt possibles</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Aucune contrainte de délai de complétion</span>
            </div>
            
        </Product>
}